export const isBrowser = typeof window !== 'undefined' && !global.__NODE__;
export const isNodeTesting = Boolean(global.__NODE_TESTING__);
export const BROWSER_TESTING_PREFIX = 'browsertesting';
export const isBrowserTestingTenant =
  typeof window !== 'undefined' && window.TENANT_SUBDOMAIN?.startsWith(BROWSER_TESTING_PREFIX) === true;
export const isBrowserTesting =
  (typeof window !== 'undefined' && 'Cypress' in window) || isBrowserTestingTenant;
// eslint-disable-next-line no-restricted-globals
export const supportsBroadcastChannel = 'BroadcastChannel' in self;
